export default {"src":"/login-app/[GIT_HASH]/_next/static/media/alternate_email.6df49a3c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};